import { render, staticRenderFns } from "./deposit_record.vue?vue&type=template&id=60ab37e9&"
import script from "./deposit_record.vue?vue&type=script&lang=js&"
export * from "./deposit_record.vue?vue&type=script&lang=js&"
import style0 from "./deposit_record.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports